export default __webpack_public_path__ + "static/media/3536 cutlery side.6d309536.png";